<style>
	.active {
		border-bottom: 2px solid green;
	}
	.active > a {
		color: green;
	}
	.inactive {
		/* border-bottom: 2px solid #f7f7f7;	 */
	}
	.inactive > a {
		color: grey;
	}
	#profile {
		box-shadow: none;
		border: 1px solid #ddd;
	}
</style>
<template>
	<main id="profile-page">
		<section  class="vx-row justify-center">
			<div class="vx-col w-full lg:w-full">
				<vx-card id="profile">
					<header class="mt-6 mb-8">
						<nav class="block md:hidden">
							<vs-collapse>
								<vs-collapse-item>
									<div slot="header">Profile</div>
									<ul>
										<li
											v-for="(item, i) in navbar"
											:key="i"
											class="py-2"
										>
											<a href="#" @click="setActiveComponent(item.id)" class="text-center block">
												<small>
												<strong>{{ item.name }}</strong>
												</small>
											</a>
										</li>
									</ul>
								</vs-collapse-item>
							</vs-collapse>
						</nav>
						<nav class="vx-row justify-start hidden md:flex">
							<div 
								class="menu vx-col w-1/6 pb-6"
								v-for="(item, i) in filteredNavbar"
								:key="i"
								:id="item.id"
								:class="item.class"
							>
								<a href="#" @click="setActiveComponent(item.id)" class="text-center block">
									<small>
									<strong>{{ item.name }}</strong>
									</small>
								</a>
							</div>
						</nav>
						<div class="w-full" style="border: 1px solid #ddd;"></div>
					</header>
					<section class="mx-6 mb-6">
						<component 
							@viewTransaction="viewTransaction"
							@addBankPayment="addBankPayment"
							@addOnlinePayment="addOnlinePayment"
							@editProfile="editProfile" 
							@verifyData="verifyData"
							@backProfilePayment="backProfilePayment"
							@updateProfile="updateProfile"
							@changePassword="changePassword"
							@changePIN="changePIN"
							@successChangePIN="successChangePIN"
							@viewQurbanProgress="viewQurbanProgress"
							:is="activeComponent"
						></component>
					</section>
				</vx-card>
			</div>
		</section>
	</main>
</template>
<script>
import { mapState } from 'vuex'
import defaultProfile from '@/assets/images/profile/default.jpg'
import { roleFeatures } from '@/assets/utils/user_roles'

export default {
	components: {
		ProfileBiodata: () => import('./components/ProfileBiodata.vue'),
		ProfileEdit: () => import('./ProfileEdit.vue'),
		ProfilePayment: () => import('./components/ProfilePayment.vue'),
		ProfileBankPayment: () => import('./components/ProfileBankPayment.vue'),
		ProfileOnlinePayment: () => import('./components/ProfileOnlinePayment.vue'),
		ProfileHistoryTransaction: () => import('./components/ProfileHistoryTransaction.vue'),
		ProfileTransaction: () => import('./components/ProfileTransaction.vue'),
		ProfileDocument: () => import('./components/ProfileDocument.vue'),
		ProfileVerifyData: () => import('./components/ProfileVerifyData.vue'),
		ProfilePM: () => import('./components/ProfilePM.vue'),
		ProfileChangePassword: () => import('./components/ProfileChangePassword.vue'),
		ProfileChangePIN: () => import('./components/ProfileChangePIN.vue'),
		ProfileSecurity: () => import('./components/ProfileSecurity.vue'),
		ProfileQurbanProgress: () => import('./components/ProfileQurbanProgress.vue')
	},
	computed: {
		...mapState('auth', ['profile'])
	},
	methods: {
		viewQurbanProgress(item) {
			this.activeComponent = 'ProfileQurbanProgress';
		},
		updateProfile() {},
		successChangePIN() {
			this.activeComponent = 'ProfileBiodata'
			document.getElementsByClassName('menu').forEach(item => {
				item.setAttribute('class', 'menu vx-col w-1/6 pb-6 inactive')
			})

			document.getElementById('ProfileBiodata')
					.setAttribute('class', 'menu vx-col w-1/6 pb-6 active')
		},
		changePIN() {
			this.activeComponent = 'ProfileChangePIN'
		},
		changePassword() {
			this.activeComponent = 'ProfileChangePassword'
		},
		viewTransaction(type) {
			this.$store.dispatch('setViewTransactionType', type)
			this.activeComponent = 'ProfileTransaction'
		},
		verifyData() {
			this.activeComponent = 'ProfileVerifyData'
		},
		backProfilePayment() {
			this.activeComponent = 'ProfilePayment'
		},
		addBankPayment() {
			this.activeComponent = 'ProfileBankPayment'
		},
		addOnlinePayment() {
			this.activeComponent = 'ProfileOnlinePayment'
		},
		editProfile() {
			this.activeComponent = 'ProfileEdit'
		},
		setActiveComponent(id) {
			// 
			document.getElementsByClassName('menu').forEach(item => {
				item.setAttribute('class', 'menu vx-col w-1/6 pb-6 inactive')
			})

			document.getElementById(id)
					.setAttribute('class', 'menu vx-col w-1/6 pb-6 active')
			this.activeComponent = id
		}
	},
	created() {
		this.filteredNavbar = this.navbar.filter(item => item.permission.includes(this.profile.level.slug))	
	},
	data: () => ({
		activeComponent: 'ProfileBiodata',
		filteredNavbar: [],
		navbar: [
			{
				id: 'ProfileBiodata',
				name: 'Biodata Diri',
				class: 'active',
				permission: ['user', 'sahabatzx']
			},
			{
				id: 'ProfileHistoryTransaction',
				name: 'Riwayat Transaksi',
				class: 'inactive',
				permission: ['user','sahabatzx']
			},
			{
				id: 'ProfilePM',
				name: 'Manfaat Diterima',
				class: 'inactive',
				permission: ['sahabatzx', 'user']
			},
			{
				id: 'ProfileDocument',
				name: 'Kelengkapan Persyaratan',
				class: 'inactive',
				permission: ['sahabatzx']
			},
			{
				id: 'ProfileSecurity',
				name: 'Keamanan Akun',
				class: 'inactive',
				permission: ['user', 'sahabatzx']
			}
		]
	})
}
</script>